import Hero from '../components/Hero';
import CampersSection from '../components/CampersSection';
import { DestinationsSection } from '../components/DestinationsSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { FaqSection } from '../components/FaqSection';
import { CtaSection } from '../components/CtaSection';
import { ContactSection } from '../components/ContactSection';

export function Home() {
  return (
    <main>
      <h1 className="sr-only">Alquiler de Furgonetas Camper en Galicia - Furgos Río</h1>
      <Hero />
      <article>
        <CampersSection />
      </article>
      <article>
        <DestinationsSection />
      </article>
      <article>
        <FeaturesSection />
      </article>
      <section>
        <FaqSection />
      </section>
      <section>
        <CtaSection />
      </section>
      <section>
        <ContactSection />
      </section>
    </main>
  );
}
